import { atomWithStorage } from "jotai/utils";

export interface AuctionWizardStateAtom {
  activeStep: number;
  previousStep: number;
  /** Matches client auction id so persisted step is not reused across listings */
  auctionId?: number;
}

export const auctionWizardStateAtom = atomWithStorage<AuctionWizardStateAtom>(
  "auctionWizardStateAtom",
  { activeStep: 0, previousStep: 0 },
  undefined,
  { getOnInit: true }
);
